type GroupedEntry = { group?: string };

const firstAppearance = (entries: readonly GroupedEntry[]): Array<string | undefined> => entries.reduce<Array<string | undefined>>((order, entry) => (order.includes(entry.group) ? order : [...order, entry.group]), []);

export const orderGroups = (entries: readonly GroupedEntry[], named: readonly string[]): Array<string | undefined> => {
  const appearing = firstAppearance(entries);
  if (named.length === 0) return appearing;
  const ungrouped = appearing.includes(undefined) ? [undefined] : [];
  const unnamed = appearing.filter((group): group is string => group !== undefined && !named.includes(group));
  return [...ungrouped, ...named, ...unnamed];
};
